import { Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './modules/rootReducer';
import rootSaga from './modules/rootSaga';

import createStore from './createStore';
import { ApplicationState } from './store.inteface';

const sagaMiddleware = createSagaMiddleware({});

const middlewares = [sagaMiddleware];
const store: Store<ApplicationState> = createStore(rootReducer, middlewares);

sagaMiddleware.run(rootSaga);

export { store };
